import React from 'react'
import {FormattedNumber} from 'react-intl'
import EmptyStar from '../../assets/icons/EmptyStar.svg'
import FullStar from '../../assets/icons/FullStar.svg'
import HalfStar from '../../assets/icons/HalfStar.svg'
import {maxStars} from '../../config/constants'
import styles from './Stars.scss'

export interface IStarsProps {
  stars: number
  total?: number
  starsOnly?: boolean
  hideTotal?: boolean
  className?: string
  isCar?: boolean
  isStation?: boolean
}
const Stars = ({stars, total, starsOnly, hideTotal, onReviewLinkClick, starsStyle, ...props}: IStarsProps & {
  onReviewLinkClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void,
  starsStyle: string
}) => {
  stars = Math.max(0, Math.min(stars, maxStars))
  const fullStars = Math.floor(stars)
  const halfStars = (stars > fullStars + 0.2) ? 1 : 0
  const emptyStars = maxStars - fullStars - halfStars
  const starsPanel = <>
    {[...Array(fullStars).keys()].map(index => <FullStar key={index} className={['fa mb-1', styles.starColor].join(' ')}/>)}
    {[...Array(halfStars).keys()].map(index => <HalfStar key={index} className={['fa mb-1', styles.starColor].join(' ')}/>)}
    {[...Array(emptyStars).keys()].map(index => <EmptyStar key={index} className={['fa mb-1', styles.starColor].join(' ')}/>)}
  </>
  return <div {...props}>
    {starsPanel}
    {!starsOnly && <div onClick={onReviewLinkClick}
                        className={['d-inline-block ml-1 text-primary', styles.stars, starsStyle, 'small'].join(' ')}>
        <FormattedNumber value={stars} minimumFractionDigits={2} maximumFractionDigits={2}/>
        { !hideTotal && <>&nbsp;({total || 0})</> }
      </div>
    }
  </div>
}
Stars.displayName = 'Stars'
export default Stars
